import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    defaultMessage: 'None of the accounts are available to make this payment',
    id: 'AccountsErrorOverlay.title',
  },
  text: {
    defaultMessage: 'Please try again with another bank.',
    id: 'AccountsErrorOverlay.text',
  },
  bankSelection: {
    defaultMessage: 'Try again',
    id: 'BackButton.bankselection',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'AccountsErrorOverlay.cancel',
  },
});
